<template>
  <div class="container">
    <el-tabs v-model="activeName">
      <el-tab-pane label="问卷查询" name="first">
        <DataCenter v-if="activeName === 'first'" />
      </el-tab-pane>
      <el-tab-pane label="CRF模板" name="second">
        <div class="main" v-if="activeName === 'second'">
          <div class="box">
            <div class="questionnaire-content">
              <div class="header">
                <div class="header-left">
                  <span>项目</span>
                  <el-select v-model="value" placeholder="请选择" @change="ProjectChange">
                    <el-option v-for="(item, index) in Project" :key="index" :label="item.Name" :value="item.Id"></el-option>
                  </el-select>
                  <span>关键字:</span>
                  <el-input placeholder="请输入关键字搜索" v-model="listQuery.Key"></el-input>
                  <el-button icon="el-icon-search" @click="search">查询</el-button>
                  <el-button icon="el-icon-plus" @click="AddProject" v-if="admin != '00000000-0000-0000-0000-000000000000'">加入项目</el-button>
                </div>
                <div class="header-right">
                  <el-button v-if="admin != '00000000-0000-0000-0000-000000000000' && RoleType === 'D'" @click="AddQuestionnaire">+新建</el-button>
                </div>
              </div>
              <div class="content">
                <el-table
                  ref="multipleTable"
                  :data="QuestionnaireTable"
                  tooltip-effect="dark"
                  style="width: 100%; margin-bottom: 10px"
                  height="90%"
                  border
                  :header-cell-style="{ background: 'rgb(240, 247, 253)' }"
                >
                  <el-table-column type="selection" width="45" align="center"></el-table-column>
                  <el-table-column type="index" width="60" align="center" label="序号"></el-table-column>
                  <el-table-column prop="Name" label="问卷名称" min-width="80" align="center" :sortable="true" :sort-method="sortByVesselName"></el-table-column>
                  <el-table-column prop="CollectedQty" label="已收集问卷数" width="120" align="center"></el-table-column>
                  <el-table-column label="是否发布" width="150" align="center">
                    <template slot-scope="scope">
                      <span>{{ scope.row.IsPublic == true ? '已发布' : '未发布' }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column prop="OwnerName" label="问卷创建人" width="180" align="center"></el-table-column>
                  <el-table-column prop="CreateTime" label="创建时间" width="180" align="center" sortable></el-table-column>
                  <el-table-column label="操作" width="550" align="center">
                    <template slot-scope="scope">
                      <el-link :underline="false" @click="SeeQuestionnaire(scope.row)">
                        <img src="../../assets/image/icon/search.png" alt style="vertical-align: middle" />
                        查看
                      </el-link>
                      <el-link v-if="admin != '00000000-0000-0000-0000-000000000000' && RoleType == 'D'" :underline="false" @click="EditQuestionnaire(scope.row)">
                        <i class="el-icon-edit-outline"></i>
                        修改
                      </el-link>
                      <el-link v-if="admin != '00000000-0000-0000-0000-000000000000' && RoleType == 'D'" :underline="false" class="del" size="mini" @click="DeleteQuestionnaire(scope.row)">
                        <i class="el-icon-delete"></i>
                        删除
                      </el-link>

                      <el-popconfirm :title="scope.row.IsPublic == false ? '确定要发布吗' : '确定要取消发布吗'" @confirm="showPublish(scope.row)">
                        <template #reference>
                          <el-link v-if="admin != '00000000-0000-0000-0000-000000000000' && RoleType == 'D'" :underline="false">
                            <i class="el-icon-video-pause"></i>
                            {{ scope.row.IsPublic == false ? '确定发布' : '取消发布' }}
                          </el-link>
                        </template>
                      </el-popconfirm>

                      <!-- issueState -->
                      <el-link v-if="admin != '00000000-0000-0000-0000-000000000000' && RoleType == 'D'" @click="JoinProject(scope.row)" :underline="false">
                        <i class="el-icon-circle-plus-outline"></i>
                        加入项目
                      </el-link>
                      <el-link v-if="admin != '00000000-0000-0000-0000-000000000000' && RoleType == 'D'" @click="toNaPai(scope.row)" :underline="false">
                        <i class="el-icon-circle-plus-outline"></i>
                        纳排标准
                      </el-link>
                      <el-link v-if="admin != '00000000-0000-0000-0000-000000000000' && RoleType == 'D'" @click="setData(scope.row)" :underline="false">
                        <i class="el-icon-link"></i>
                        同步数据
                      </el-link>
                      <el-link v-if="admin != '00000000-0000-0000-0000-000000000000' && RoleType == 'D'" @click="bindData(scope.row)" :underline="false">
                        <i class="el-icon-paperclip"></i>
                        绑定字段
                      </el-link>
                      <el-link v-if="admin != '00000000-0000-0000-0000-000000000000' && RoleType == 'D'" @click="downLoad(scope.row)" :underline="false">
                        <i class="el-icon-sort-down"></i>
                        模板下载
                      </el-link>

                      <el-link @click="toUpload(scope.row)" v-if="admin != '00000000-0000-0000-0000-000000000000' && RoleType == 'D'" :underline="false">
                        <i class="el-icon-sort-up"></i>
                        <el-upload style="inline-block" class="avatar-uploader" accept=".xlsx, .xls" multiple action="#" :http-request="httpRequest" :file-list="fileList">
                          <span style="margin-left: 5px">数据导入</span>
                        </el-upload>
                      </el-link>
                    </template>
                  </el-table-column>
                </el-table>
                <Pagination :total="total" :page.sync="listQuery.page" :limit.sync="listQuery.rows" @pagination="GetPageList(value)"></Pagination>
              </div>
            </div>
          </div>
          <div class="addQuestionnaire">
            <el-dialog :visible.sync="addQuestionnaireVisible" :fullscreen="true" @close="close">
              <iframe frameborder="0" name="myFrame" id="myFrame" scrolling="yes" width="100%" height="1080px" :src="mUrl"></iframe>
            </el-dialog>
          </div>
          <div class="addProject">
            <el-dialog :visible.sync="QuestionnaireDialog" width="30%">
              <div slot="title" class="header-title">
                <span class="title-name"></span>
                <span class="title-age">加入项目</span>
              </div>
              <div style="margin-bottom: 20px" class="div_select">
                <div style="margin-bottom: 20px">
                  <span style="margin-right: 20px">项目:</span>
                  <el-select v-model="Pvalue" placeholder="请选择" @change="PvalueChange" style="width: 90%">
                    <el-option v-for="(item, index) in ProjectArr" :key="index" :label="item.Name" :value="item.Id"></el-option>
                  </el-select>
                </div>
                <div>
                  <span style="margin-right: 20px">问卷:</span>
                  <el-select v-model="Qvalue" placeholder="请选择" multiple value-key="Id" style="width: 90%">
                    <el-option v-for="(item, index) in QuestionnaireList" :key="index" :label="item.questionnaireName" :value="item"></el-option>
                  </el-select>
                </div>
              </div>
              <div class="btn">
                <button @click="QuestionnaireDialog = false">取消</button>
                <button type="primary" @click="AddProjectQuestionnaire">确定</button>
              </div>
            </el-dialog>
          </div>
          <div class="addProject">
            <el-dialog :visible.sync="ButQuestionnaireDialog" width="30%">
              <div slot="title" class="header-title">
                <span class="title-name"></span>
                <span class="title-age">加入项目</span>
              </div>
              <div style="margin-bottom: 20px" class="div_select">
                <div style="margin-bottom: 20px">
                  <span style="margin-right: 20px">项目:</span>
                  <el-select v-model="ButPvalue" placeholder="请选择" @change="PvalueChange">
                    <el-option v-for="(item, index) in ProjectArr" :key="index" :label="item.Name" :value="item.Id"></el-option>
                  </el-select>
                </div>
              </div>
              <div class="btn">
                <button @click="ButQuestionnaireDialog = false">取消</button>
                <button type="primary" @click="ButAddProjectQuestionnaire">确定</button>
              </div>
            </el-dialog>
          </div>
        </div>
      </el-tab-pane>
      <el-tab-pane label="科研插件" name="third">
        <div class="main" v-if="activeName === 'third'">
          <div class="box">
            <div class="questionnaire-content">
              <div class="header">
                <div class="header-left">
                  <span>项目</span>
                  <el-select v-model="value" placeholder="请选择" @change="ProjectChange">
                    <el-option v-for="(item, index) in Project" :key="index" :label="item.Name" :value="item.Id"></el-option>
                  </el-select>
                  <span>关键字:</span>
                  <el-input placeholder="请输入关键字搜索" v-model="listQuery.Key"></el-input>
                  <el-button icon="el-icon-search" @click="search">查询</el-button>
                  <el-button icon="el-icon-plus" @click="AddTemplate" v-if="admin != '00000000-0000-0000-0000-000000000000'">加入模板</el-button>
                </div>
                <div class="header-right">
                  <el-button v-if="admin != '00000000-0000-0000-0000-000000000000' && RoleType === 'D'" @click="AddQuestionnaire">+新建问卷</el-button>
                </div>
              </div>
              <div class="content">
                <el-table
                  ref="multipleTable"
                  :data="QuestionnaireTable"
                  tooltip-effect="dark"
                  style="width: 100%; margin-bottom: 10px"
                  height="90%"
                  border
                  :header-cell-style="{ background: 'rgb(240, 247, 253)' }"
                  @select="handleSelect"
                >
                  <el-table-column type="selection" width="45" align="center"></el-table-column>
                  <el-table-column type="index" width="60" align="center" label="序号"></el-table-column>
                  <el-table-column prop="Name" label="插件名称" min-width="80" align="center" :sortable="true" :sort-method="sortByVesselName"></el-table-column>
                  <el-table-column prop="OwnerName" label="创建人" width="180" align="center"></el-table-column>
                  <el-table-column prop="CreateTime" label="创建时间" width="180" align="center" sortable></el-table-column>
                  <el-table-column label="操作" width="500" align="center">
                    <template slot-scope="scope">
                      <el-link :underline="false" @click="SeeQuestionnaire(scope.row)">
                        <img src="../../assets/image/icon/search.png" alt style="vertical-align: middle" />
                        查看
                      </el-link>
                      <el-link v-if="admin != '00000000-0000-0000-0000-000000000000' && RoleType == 'D'" :underline="false" @click="EditQuestionnaire(scope.row)">
                        <i class="el-icon-edit-outline"></i>
                        修改
                      </el-link>
                      <el-link v-if="admin != '00000000-0000-0000-0000-000000000000' && RoleType == 'D'" :underline="false" class="del" size="mini" @click="DeleteQuestionnaire(scope.row)">
                        <i class="el-icon-delete"></i>
                        删除
                      </el-link>
                      <!-- issueState -->
                    </template>
                  </el-table-column>
                </el-table>
                <Pagination :total="total" :page.sync="listQuery.page" :limit.sync="listQuery.rows" @pagination="GetPageList(value)"></Pagination>
              </div>
            </div>
          </div>
          <div class="addQuestionnaire">
            <el-dialog :visible.sync="addQuestionnaireVisible" :fullscreen="true" @close="close">
              <iframe frameborder="0" name="myFrame" id="myFrame" scrolling="yes" width="100%" height="1080px" :src="mUrl"></iframe>
            </el-dialog>
          </div>
          <div class="addProject">
            <el-dialog :visible.sync="QuestionnaireDialog" width="30%">
              <div slot="title" class="header-title">
                <span class="title-name"></span>
                <span class="title-age">加入项目</span>
              </div>
              <div style="margin-bottom: 20px" class="div_select">
                <div style="margin-bottom: 20px">
                  <span style="margin-right: 20px">项目:</span>
                  <el-select v-model="Pvalue" placeholder="请选择" @change="PvalueChange" style="width: 90%">
                    <el-option v-for="(item, index) in ProjectArr" :key="index" :label="item.Name" :value="item.Id"></el-option>
                  </el-select>
                </div>
                <div>
                  <span style="margin-right: 20px">问卷:</span>
                  <el-select v-model="Qvalue" placeholder="请选择" multiple value-key="Id" style="width: 90%">
                    <el-option v-for="(item, index) in QuestionnaireList" :key="index" :label="item.questionnaireName" :value="item"></el-option>
                  </el-select>
                </div>
              </div>
              <div class="btn">
                <button @click="QuestionnaireDialog = false">取消</button>
                <button type="primary" @click="AddProjectQuestionnaire">确定</button>
              </div>
            </el-dialog>
          </div>
          <div class="addProject">
            <el-dialog :visible.sync="ButQuestionnaireDialog" width="30%">
              <div slot="title" class="header-title">
                <span class="title-name"></span>
                <span class="title-age">加入项目</span>
              </div>
              <div style="margin-bottom: 20px" class="div_select">
                <div style="margin-bottom: 20px">
                  <span style="margin-right: 20px">项目:</span>
                  <el-select v-model="ButPvalue" placeholder="请选择" @change="PvalueChange">
                    <el-option v-for="(item, index) in ProjectArr" :key="index" :label="item.Name" :value="item.Id"></el-option>
                  </el-select>
                </div>
              </div>
              <div class="btn">
                <button @click="ButQuestionnaireDialog = false">取消</button>
                <button type="primary" @click="ButAddProjectQuestionnaire">确定</button>
              </div>
            </el-dialog>
          </div>
        </div>
      </el-tab-pane>
    </el-tabs>
    <!-- 绑定字段 -->
    <div class="x">
      <el-dialog :visible.sync="bindDialog" width="50%">
        <div slot="title" class="header-title">
          <span class="title-name"></span>
          <span class="title-age">绑定字段</span>
        </div>
        <div style="margin-bottom: 20px" class="div_select">
          <el-form label-position="right" label-width="120px" :model="bindFormData" :rules="rules" ref="bindFormData">
            <!-- 单选疼痛  1手术  2慢性-->
            <el-form-item label="病痛类型" prop="type">
              <el-radio-group v-model="bindFormData.type">
                <el-radio :label="1">手术疼痛</el-radio>
                <el-radio :label="2">慢性疼痛</el-radio>
              </el-radio-group>
            </el-form-item>
            <div v-if="bindFormData.type == 1">
              <el-form-item label="性别" prop="sex">
                <el-select filterable v-model="bindFormData.sex" placeholder="请选择">
                  <el-option :disabled="item.disabled" v-for="item in arr" :key="item.id" :label="item.name" :value="item.id"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="年龄" prop="age">
                <el-select filterable v-model="bindFormData.age" placeholder="请选择">
                  <el-option :disabled="item.disabled" v-for="(item, index) in arr" :key="index" :label="item.name" :value="item.id"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="体重" prop="weight">
                <el-select filterable v-model="bindFormData.weight" placeholder="请选择">
                  <el-option :disabled="item.disabled" v-for="(item, index) in arr" :key="index" :label="item.name" :value="item.id"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="肿瘤类型" prop="tumorType">
                <el-select filterable v-model="bindFormData.tumorType" placeholder="请选择">
                  <el-option :disabled="item.disabled" v-for="(item, index) in arr" :key="index" :label="item.name" :value="item.id"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="肿瘤性质" prop="tumorNature">
                <el-select filterable v-model="bindFormData.tumorNature" placeholder="请选择">
                  <el-option :disabled="item.disabled" v-for="(item, index) in arr" :key="index" :label="item.name" :value="item.id"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="手术方式" prop="surgeryMethod">
                <el-select filterable v-model="bindFormData.surgeryMethod" placeholder="请选择">
                  <el-option :disabled="item.disabled" v-for="(item, index) in arr" :key="index" :label="item.name" :value="item.id"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="部位层次归属" prop="surgerySite">
                <el-select filterable v-model="bindFormData.surgerySite" placeholder="请选择">
                  <el-option :disabled="item.disabled" v-for="(item, index) in arr" :key="index" :label="item.name" :value="item.id"></el-option>
                </el-select>
              </el-form-item>
            </div>
          </el-form>
        </div>
        <div class="btn">
          <button @click="bindDialog = false">取消</button>
          <button type="primary" @click="bindAdd">确定</button>
        </div>
      </el-dialog>
    </div>
    <ProjectTongBu v-if="showTogether" ref="ProjectTongBu" :Qid="Qid" :ProjectId="ProjectId" @closeTogeter="closeTogeter"></ProjectTongBu>
    <ProjectNaPai v-if="showNaPai" :QName="QName" :Qid="Qid" :ProjectId="ProjectId" @closeDialog="closeDialog" ref="ProjectNaPai"></ProjectNaPai>
  </div>
</template>

<script>
import ProjectNaPai from '@/components/ProjectNaPai';
import ProjectTongBu from '@/components/ProjectTongBu.vue';
import { local } from '@/utils/storage';
import { BindDiagnosisCondition, GetListBySystem, QuestionnaireTemplates, QuestionnaireUpload } from '../../api/DataMapping';
import derive from '../../api/derive';
import questionnaire from '../../api/questionnaire';
import Pagination from '../../components/Pagination/index.vue';
import DataCenter from './DataCenter';
export default {
  name: 'questionnaire',
  data() {
    return {
      ProjectId: null,
      showTogether: false,
      showNaPai: false,
      QName: '',
      Qid: '',
      fileList: [],
      disabledArr: [],
      activeName: 'second',
      arr: [],
      bindDialog: false,
      bindFormData: {},
      bindFormType: null,
      rules: {
        type: [{ required: true, message: '请选择病痛类型', trigger: 'change' }],
        sex: [{ required: true, message: '请选择性别', trigger: 'change' }],
        age: [
          {
            required: true,
            message: '请选择年龄',
            trigger: 'change'
          }
        ],
        weight: [
          {
            required: true,
            message: '请选择体重',
            trigger: 'change'
          }
        ],

        tumorType: [
          {
            required: true,
            message: '请选择肿瘤类型',
            trigger: 'change'
          }
        ],
        tumorNature: [
          {
            required: true,
            message: '请选择肿瘤性质',
            trigger: 'change'
          }
        ],
        surgeryMethod: [
          {
            required: true,
            message: '请选择手术方式',
            trigger: 'change'
          }
        ],
        surgerySite: [
          {
            required: true,
            message: '请选择部位层次归属',
            trigger: 'change'
          }
        ]
      },
      ButQuestionnaireDialog: false,
      admin: local.get('UserId'),
      list: [],
      Pvalue: '',
      Qvalue: '',
      ButPvalue: '',
      ButQvalue: '',
      QuestionnaireDialog: false,
      value: '',
      Project: [
        {
          Name: '全部',
          Id: 'all'
        },
        {
          Name: '其他',
          Id: 'other'
        }
      ],
      QuestionnaireTable: [], // 问卷列表数据
      QuestionnaireList: [],
      ProjectArr: [],
      seeQuestionnaireVisible: false,
      mUrl: '', //问卷地址
      addQuestionnaireVisible: false,
      mouseNum: -1,
      total: 0,
      listQuery: {
        Key: '',
        page: 1,
        rows: 20
      },
      RoleType: '',
      selectIdArr: []
    };
  },
  components: {
    Pagination,
    DataCenter,
    ProjectNaPai,
    ProjectTongBu
  },
  created() {
    this.RoleType = local.get('RoleType');
    this.value = 'all';
    this.ProjectList();
  },
  methods: {
    closeTogeter() {
      this.showTogether = false;
      this.$refs.ProjectTongBu.dialogVisible = false;
    },
    toUpload(row) {
      this.qid = row.Id;
    },
    ////////////////////////////////下载

    httpRequest(file) {
      console.log(file);
      let formData = new FormData();
      formData.append('file', file.file);
      formData.append('qid', this.qid);
      QuestionnaireUpload(formData).then(res => {
        console.log(res);
        if (res.data == '导入成功') {
          this.$message({
            message: '导入成功',
            type: 'success'
          });
        } else {
          this.$message({
            message: res.data.Message,
            type: 'warning'
          });
          // alert(res.data.Message);
        }
      });
      console.log(formData);
    },

    //通过文字进行排序
    sortByVesselName(obj1, obj2) {
      if ([obj1.Name, obj2.Name][0] == [obj1.Name, obj2.Name].sort((a, b) => a.localeCompare(b, 'zh', { sensitivity: 'accent' }))[0]) {
        return -1;
      } else {
        return 1;
      }
    },
    //search
    search() {
      this.listQuery.page = 1;
      this.GetPageList(this.value);
    },
    //打开单个加入项目
    JoinProject(row) {
      this.ButQvalue = row.Id;
      this.ButQuestionnaireDialog = true;
    },
    //确认添加单个项目
    ButAddProjectQuestionnaire() {
      this.list.push({
        ProjectId: this.ButPvalue,
        Id: this.ButQvalue
      });
      questionnaire.AddProjectQuestionnaireData(this.list).then(res => {
        if (res.data.Status == 1) {
          this.$message({
            message: '加入成功',
            type: 'success'
          });
          this.ProjectList();
          this.ButQuestionnaireDialog = false;
        } else {
          alert(res.data.Message);
        }
      });
    },
    //打开项目弹框
    async AddProject() {
      this.QuestionnaireDialog = true;
      this.Pvalue = '';
      this.Qvalue = '';
      await this.NothingGetPageList();
    },
    //确认添加项目
    AddProjectQuestionnaire() {
      this.list = this.Qvalue.map(row => {
        return {
          ProjectId: this.Pvalue,
          Id: row.Id
        };
      });
      questionnaire.AddProjectQuestionnaireData(this.list).then(res => {
        if (res.data.Status == 1) {
          this.$message({
            message: '加入成功',
            type: 'success'
          });
          // this.ProjectList();
          this.QuestionnaireDialog = false;
        } else {
          alert(res.data.Message);
        }
      });
    },
    PvalueChange() {
      this.Qvalue = '';
      // this.NothingGetPageList()
    },
    //问卷列表无分页
    async NothingGetPageList() {
      const parameter = {
        ProjectId: 'other'
      };
      await derive.CRFSurfaceData(parameter).then(res => {
        if (res.data.Status == 1) {
          this.QuestionnaireList = res.data.Data;
        } else {
          alert(res.data.Message);
        }
      });
    },
    ProjectChange(e) {
      this.GetPageList(e);
    },
    //项目
    async ProjectList() {
      derive.ProjectListData().then(res => {
        if (res.data.Status == 1) {
          if (res.data.Data.length != 0) {
            this.ProjectArr = JSON.parse(JSON.stringify(res.data.Data));
            // this.Project=res.data.Data
            res.data.Data.forEach(item => {
              this.Project.push(item);
            });
            // let Objall={
            //     Name:"全部",
            //     Id:"all",
            // }
            // let ObjOther={
            //     Name:"其他",
            //     Id:"other",
            // }
            this.value = 'all';
            // this.Project.unshift(ObjOther)
            // this.Project.unshift(Objall)
            // this.ProjectObj=res.data.Data[0]
            this.GetPageList(this.value);
          }
        } else {
          alert(res.data.Message);
        }
      });
    },
    close() {
      this.GetPageList(this.value);
    },
    //删除问卷
    DeleteQuestionnaire(row) {
      this.$confirm('此操作将永久删除该问卷, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        questionnaire.DeleteQuestionnaireData(row.Id).then(res => {
          if (res.data.Status == 1) {
            this.QuestionnaireTable = this.QuestionnaireTable.filter(item => {
              return row.Id != item.Id;
            });
            this.$message({
              type: 'success',
              message: '删除成功!'
            });
          } else {
            alert(res.data.Message);
          }
        });
      });
    },
    //查看问卷
    SeeQuestionnaire(row) {
      this.mUrl = '';
      this.addQuestionnaireVisible = true;
      questionnaire.SeeQuestionnaireData().then(res => {
        if (res.data.Status == 1) {
          this.mUrl = `${res.data.Data.Url}/#/PcIframe?qid=${row.Id}&access_token=${res.data.Data.access_token}&refresh_token=${res.data.Data.refresh_token}&type=3`;
        } else {
          alert(res.data.Message);
        }
      });
    },
    //新增问卷
    AddQuestionnaire() {
      // 插件：00
      // 模板：01
      console.log(this.activeName);
      questionnaire
        .CallBackQuestionnaireData({
          QType: this.activeName === 'second' ? '01' : '00',
          Type: '00'
        })
        .then(r => {
          if (r.data.Status == 1) {
            this.addQuestionnaireVisible = true;
            questionnaire.AddQuestionnaireData().then(res => {
              if (res.data.Status == 1) {
                this.mUrl = `${res.data.Data.Url}/#/PcIframe?sysData=${r.data.Data}&UserId=${res.data.Data.UserId}&OrganizationId=${res.data.Data.OrganizationId}&access_token=${res.data.Data.access_token}&refresh_token=${res.data.Data.refresh_token}&type=1`;
              } else {
                alert(res.data.Message);
              }
            });
          } else {
            alert(r.data.message);
          }
        });
    },
    //问卷列表分页
    GetPageList(Id) {
      const parameter = {
        ProjectId: Id,
        Key: this.listQuery.Key,
        page: this.listQuery.page,
        rows: this.listQuery.rows,
        QType: this.activeName === 'second' ? '01' : '00'
      };
      questionnaire.QGetPageListData(parameter).then(res => {
        if (res.data.Status == 1) {
          this.total = res.data.Data.total;
          this.QuestionnaireTable = res.data.Data.rows;
        } else {
          alert(res.data.Message);
        }
      });
    },
    // 修改问卷
    EditQuestionnaire(row) {
      this.addQuestionnaireVisible = true;
      questionnaire.EditQuestionnaireData().then(res => {
        if (res.data.Status == 1) {
          this.mUrl = `${res.data.Data.Url}/#/PcIframe?qid=${row.Id}&access_token=${res.data.Data.access_token}&refresh_token=${res.data.Data.refresh_token}&type=2`;
        } else {
          alert(res.data.Message);
        }
      });
    },
    //发布问卷
    showPublish(row) {
      let parameter = {};
      let issueState = true;
      if (row.IsPublic == false) {
        issueState = true;
        parameter = {
          id: row.Id,
          issueState: issueState
        };
      } else {
        issueState = false;
        parameter = {
          id: row.Id,
          issueState: issueState
        };
      }
      questionnaire.PublicQuestionnaireData(parameter).then(res => {
        if (res.data.Status == 1) {
          this.$message({
            message: res.data.Message,
            type: 'success'
          });
          // if(issueState){
          //       this.$message({
          //         message: '发布成功',
          //         type: 'success'
          //       });
          //   }else{
          //        this.$message({
          //         message: '取消发布',
          //         type: 'success'
          //       });
          //   }
          this.QuestionnaireTable = this.QuestionnaireTable.map(item => {
            if (item.Id == row.Id) {
              item.IsPublic = issueState;
            }
            return item;
          });
        } else {
          alert(res.data.Message);
        }
      });
    },
    async AddTemplate() {
      if (this.selectIdArr.length === 0) return this.$message.error('请勾选问卷');
      let res = await questionnaire.addTemplate(this.selectIdArr);
      this.$message.success('加入成功');
      this.GetPageList('all');
    },
    handleSelect(selection, row) {
      let arr = [];
      selection.forEach(i => {
        arr.push(i.Id);
      });
      this.selectIdArr = arr;
    },
    async setData(row) {
      this.Qid = row.Id;
      this.QName = row.Name;
      this.ProjectId = row.ProjectId;
      console.log(row);
      this.showTogether = true;
      this.$nextTick(() => {
        this.$refs.ProjectTongBu.dialogVisible = true;
      });

      // let res = await derive.setDataApi(row.Id);
      // this.$message.success('同步成功');
    },

    closeDialog() {
      this.showNaPai = false;
    },
    async toNaPai(row) {
      this.Qid = row.Id;
      this.QName = row.Name;
      this.ProjectId = row.ProjectId;
      if (!this.ProjectId) {
        this.$message.warning('请先将问卷加入项目');
        return;
      }
      this.showNaPai = true;
      this.$nextTick(() => {
        this.$refs.ProjectNaPai.dialogVisible = true;
      });

      console.log(row);
    },
    async bindData(row) {
      // GetListBySystem
      this.bindFormData = {
        type: 1
      };
      this.disabledArr = [];
      this.rowId = row.Id;
      GetListBySystem(row.Id).then(res => {
        this.arr = res.data;
        console.log(this.arr);
      });
      this.bindDialog = true;
    },
    bindAdd() {
      var obj;
      // 与bindFormData 表单对照对象
      switch (this.bindFormData.type) {
        case 1:
          obj = {
            type: 'ApiType',
            sex: '性别',
            age: '年龄',

            weight: '体重',

            tumorType: '肿瘤类型',

            tumorNature: '肿瘤性质',

            surgeryMethod: '手术方式',

            surgerySite: '部位层次归属'
          };

          break;
        case 2:
          obj = {};
          break;
      }

      this.$refs.bindFormData.validate(valid => {
        if (valid) {
          // 将表单数据的key转换成obj的值
          const newObj = {};
          Object.keys(this.bindFormData).forEach(key => {
            newObj[obj[key]] = this.bindFormData[key];
          });
          console.log(newObj);
          var ApiType = newObj.ApiType;
          var qid = this.rowId;
          const params = [];
          // 传参 遍历newObj
          for (let key in newObj) {
            if (key != 'ApiType') {
              params.push({
                BindId: newObj[key],
                ConditionName: key,
                ApiType
              });
            }
          }
          //  遍历新数组与this.arr进行对照，如果BindId与this.arr的id相等，则追加typeName到params中
          params.forEach(item => {
            this.arr.forEach(itemc => {
              if (item.BindId === itemc.id) {
                item.TypeName = itemc.typeName;
              }
            });
          });
          console.log(params);
          BindDiagnosisCondition(qid, params).then(res => {
            console.log(res);
            this.bindDialog = false;
            this.disabledArr = [];
            this.$message.success('绑定成功');
          });
          // console.log(params);
          // this.bindDialog = false;
        }
      });
    },
    downLoad(row) {
      QuestionnaireTemplates(row.id).then(res => {
        var tableData = res.data;

        import('@/utils/excelSpecial').then(excel => {
          const tHeader = tableData;
          // const filterVal = this.choseArr.map(e => {
          //   return e.DataMappingId;
          // });
          // const list = this.tableDataExcel;
          // const data = this.formatJson(filterVal, list);
          excel.export_json_to_excel({
            header: tHeader,
            data: [],
            filename: row.Name,
            autoWidth: true,
            bookType: 'xlsx'
          });
          this.$message.success('模板正在下载');
          this.downloadLoading = false;
        });

        console.log(res);
      });
    }
  },
  watch: {
    activeName: {
      handler(val) {
        if (val === 'first') return;
        this.GetPageList('all');
      },
      immediate: true
    },
    bindFormData: {
      handler(val, old) {
        // 遍历选项
        console.log(val, old);
        for (let key in val) {
          // 如果和this.arr中的某一项Id相等，则添加disable为true的属性
          this.arr.forEach(item => {
            if (item.id === val[key]) {
              // 触发响应式
              // 遍历 this.disabledArr, 如果key在 this.disabledArr的属性，则将disabled重置为false
              this.disabledArr.forEach((e, index) => {
                if (e[key]) {
                  this.arr.forEach((itemc, indexc) => {
                    if ((e[key] = itemc.id)) {
                      this.$set(itemc, 'disabled', false);
                      this.disabledArr.splice(index, 1);
                    }
                  });
                }
              });
              this.disabledArr.push({ [key]: item.id });
              console.log(this.disabledArr);
              this.$set(item, 'disabled', true);
            }
          });
        }
        console.log(this.arr);
        console.log(val);
      },
      deep: true
    },
    'bindFormData.type': function (val) {
      console.log(val, this);
      this.bindFormData = {
        type: val
      };
      this.disabledArr = [];
      this.arr.forEach(item => {
        this.$set(item, 'disabled', false);
      });
    }
  }
};
</script>

<style scoped lang="scss">
@import '../../styles/mixin.scss';

:deep(.el-tabs) {
  height: 100%;

  .el-tabs__content {
    height: calc(100% - 53.5px);

    .el-tab-pane {
      height: 100%;
    }
  }
}

.container {
  width: 100%;
  height: 100%;
  background-color: #fff;
  padding: 0 20px;
  box-sizing: border-box;
}

.input1 {
  display: inline-block;
  width: 70px;

  /deep/.el-input__inner {
    width: 70px !important;
  }
}

.input2 {
  display: inline-block;
  width: 290px;

  /deep/.el-input__inner {
    width: 290px !important;
  }

  /deep/.el-input {
    width: 290px !important;
  }
}

.addProject {
  /deep/.el-dialog__body {
    padding: 30px 20px;
  }

  /deep/.el-dialog__headerbtn {
    top: 20px;
    font-size: 22px;
  }

  /deep/.el-input__inner {
    // width: 450px;
    width: 100%;
  }
}

/deep/.el-dialog .el-dialog__header {
  margin-bottom: 0;
}

/deep/.el-dialog__headerbtn {
  top: 4px;
  font-size: 22px;
}

/deep/.el-dialog__body {
  padding: 0;
}

.main {
  width: 100%;
  min-width: 1440px;
  height: 100%;
  overflow: hidden;

  .box {
    // width: calc(100% - 40px);
    // height: calc(100% - 20px);
    box-sizing: border-box;
    // padding-top: 20px;
    margin: 0 auto;

    .questionnaire-content {
      width: 100%;
      height: 100%;
      //margin-top: 20px;
      background: #fff;
      // padding: 20px 20px 0 20px;
      box-sizing: border-box;
      display: flex;
      flex-direction: column;

      /deep/ .el-button {
        padding-top: 10px;
        height: 34px;
        font-weight: 400;
        @include add-size5($font_size_14);
      }

      .header {
        display: flex;
        justify-content: space-between;
        margin-bottom: 30px;

        span {
          @include common_span;
        }

        /deep/.el-input {
          width: 240px;
          height: 34px;
          margin-right: 20px;

          .el-input__inner {
            width: 240px;
            height: 34px;
            @include add-size($font_size_16);
          }
        }

        /deep/.el-button {
          @include common_button_primary;
          margin-left: 20px;
        }

        .header-right {
          display: flex;
          cursor: pointer;

          & > div {
            display: flex;
            width: 139px;
            height: 34px;
            margin-left: 20px;
            background-size: 100% 100%;
          }

          .bg-left {
            background-image: url('../../assets/image/icon/questionnaire-left.png');
          }

          .bg-right {
            background-image: url('../../assets/image/icon/questionnaire-right.png');
          }
        }
      }
    }
  }
}

.content {
  flex: 1;

  /deep/ .el-table {
    min-height: 50vh;

    .el-link {
      margin-right: 20px;
    }
  }

  ul {
    display: flex;
    width: 100%;
    flex-wrap: wrap;

    li {
      width: 300px;
      height: 200px;
      background: #ffffff;
      opacity: 1;
      border-radius: 10px;
      margin-right: 18px;
      margin-bottom: 18px;

      .card-title-text {
        width: 260px;

        p {
          width: 260px;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          -o-text-overflow: ellipsis;
        }
      }

      .questionnaire-num {
        width: 280px;
        text-align: center;

        p {
          font-size: 20px;
          line-height: 34px;
          color: #3388ff;
        }

        span {
          @include add-size5($font_size_14);
          font-weight: 400;
          color: #666666;
        }
      }

      .card_bottom {
        position: absolute;
        bottom: 0;
        height: 30px;

        span {
          @include add-size5($font_size_14);
          font-size: 14px;
          font-weight: 400;
          color: #aaafb5;
        }

        .geng-duo {
          p {
            line-height: 40px;
            @include add-size($font_size_16);
            font-weight: 400;
            color: #585858;
          }
        }
      }
    }
  }
}

/deep/.el-radio-group {
  margin-bottom: 0;
}

/deep/ .el-radio-button {
  //padding-top: 15px;
  height: 34px;

  .el-radio-button__inner {
    height: 34px;
  }
}

.clearfix:before,
.clearfix:after {
  display: table;
  content: '';
}

.clearfix:after {
  clear: both;
}

/deep/ .el-breadcrumb__inner {
  margin-left: 6px;
  margin-right: 6px;
}

/deep/.el-tag {
  height: 24px;
  padding-top: 0;
  line-height: 24px;
}

.active {
  padding-left: 20px;

  &:hover {
    background: #edf7ff;
    color: #3388ff;
  }
}

//关联随访
.relation-Follow {
  /deep/.el-dialog {
    .el-radio-group {
      label {
        width: 230px;

        span {
          width: 230px;
        }
      }
    }

    td {
      padding: 4px 0;
    }

    .el-form {
      margin: 0 auto;

      .el-form-item {
        margin-bottom: 10px;
      }

      .el-input {
        width: 360px;
        height: 30px;

        .el-input__inner {
          width: 360px;
          height: 30px;
          line-height: 30px;
        }

        .el-select__caret {
          margin-top: 10px;
        }
      }

      .followNum {
        @include common_span;
        margin-left: 10px;
      }
    }
  }
}

.relation-Follow {
  /deep/.el-dialog {
    .el-radio-group {
      label {
        width: 230px;

        span {
          width: 230px;
        }
      }
    }

    td {
      padding: 4px 0;
    }

    .el-form {
      margin: 0 auto;

      // .el-form-item {
      //   margin-bottom: 10px;
      // }
      // .el-input {
      //   width: 360px;
      //   height: 30px;
      //   .el-input__inner {
      //     width: 360px;
      //     height: 30px;
      //     line-height: 30px;
      //   }
      //   .el-input__icon{
      //     line-height: 30px;
      //   }
      // }
      .followNum {
        @include common_span;
        margin-left: 10px;
      }
    }
  }
}

.relation-Follow {
  /deep/.el-dialog__body {
    padding: 30px;
  }
}

@media screen and (-webkit-min-device-pixel-ratio: 1.5) {
  .main {
    min-width: 0 !important;

    .box {
      .header-left {
        .el-button {
          margin-left: 5px !important;
        }
      }

      .header {
        /deep/.el-input {
          width: 100px !important;
          height: 34px;
          margin-right: 20px;

          .el-input__inner {
            width: 100px !important;
            height: 34px;
            @include add-size($font_size_16);
          }
        }
      }
    }

    .addProject {
      /deep/.el-dialog {
        width: 60% !important;
      }
    }
  }
}
/deep/.el-upload-list {
  display: none;
}
/deep/ .avatar-uploader {
  display: inline-block;
}
</style>

<style>
.el-popover {
  padding: 0 !important;
}
.x {
  .div_select {
    padding: 50px;
  }
  .btn {
    padding-bottom: 50px;
  }
}
</style>
